<template>
  <section class="hero is-fullheight-with-navbar is-info">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">
          Unavailable
        </h1>
        <h2 class="subtitle">
          This service is unavailable at the moment.
        </h2>
      </div>
    </div>
  </section>
</template>

<script>
import { reroute } from "@/utils/auth";
export default {
  data() {
    return { interval: null };
  },
  beforeDestroy() {
    if (this.interval) clearInterval(this.interval);
  },
  mounted() {
    this.interval = setInterval(async () => {
      if (await this.$store.dispatch("settings/fetchServer")) {
        reroute();
      }
    }, 3000);
  },
};
</script>
